import React, { useState } from "react";

import { Button } from "minimum-ui/core";
import { Methodology } from "types/Methodology";

import MethodologyDetails from "./Details";

const Link: React.FC<{
  methodology: Methodology | null;
  label?: string;
}> = ({ methodology, label }) => {
  const [showDetails, setShowDetails] = useState<boolean>(false);

  if (!methodology) {
    return <span>-</span>;
  }

  return (
    <>
      <Button variant="text" onClick={() => setShowDetails(true)}>
        {label || methodology.methodologyLabel || methodology.name}
      </Button>
      <MethodologyDetails
        open={showDetails}
        onClose={() => {
          setShowDetails(false);
        }}
        methodology={methodology}
      />
    </>
  );
};

export default Link;
